import type { HexString } from "@/types/general.types";

export interface GrantedPermission extends Permission {
  allPermissionsEnabled: boolean;
  backgroundColor?: string;
  isSocialAccount?: boolean;
  userId?: string;
  platform?: PlatformEnum;
}

export interface RemoveSingleDelegateType {
  delegate: HexString;
  vault: HexString;
}

export interface ModifiedPermissionsRequest {
  operation: 0 | 1; // 0 adds, 1 removes
  delegate: HexString;
  ids: number[];
  vault: HexString;
  isSocialAccount?: boolean;
  platform?: PlatformEnum;
  userId?: string;
  callData?: SocialAccountCreationRequest;
}

export interface SocialAccountQueryParamStructure {
  platform: PlatformEnum;
  userId: string;
  account: HexString;
}

export interface DelegateAddType {
  vault: HexString;
  walletAddress: HexString;
  isSocialAccount?: boolean;
  platform?: PlatformEnum;
  userId?: string;
}

export interface SocialAccountCreationRequest {
  vault: HexString;
  target: HexString;
  data: HexString;
  value: bigint;
  ids: number[];
}

export enum ChainMode {
  Sepolia = "Sepolia",
  Mainnet = "Mainnet",
}

export enum PermModOperation {
  Remove = 1,
  Add = 0,
}

export enum PlatformEnum {
  Telegram = "telegram",
  Twitter = "twitter",
  Instagram = "instagram",
}

export enum InputSwitchStateEnum {
  Platform = "Social Media Account",
  Wallet = "Wallet Address",
}

export type Permission = {
  permissionIds: number[];
  delegate: HexString;
  vault: HexString;
  _id?: string;
  source?: string;
  chain?: number;
  logIndex?: number;
  txnHash?: HexString;
  isAnimating?: boolean | undefined;
};

export enum DelegateContext {
  Granted = "Granted Permissions",
  Received = "Received Permissions",
}

export enum ModPermsQueryKeys {
  ModularPermissions = "mod-perms",
}

export interface CheckboxPermission {
  name: string;
  id: number;
}

// Return type for getToggledPermissions (returns the onchain and mirrored permissions for granted or received)
export interface ToggledResponse {
  blessnetPermissions: GrantedPermission[];
  mirroredPermissions: Permission[];
}
